import { Spin, Layout } from 'antd'
import moment from 'moment'
import { RBACEnum, GraphQlEnum } from './Enums'
import { refreshAuthToken } from './authToken'
import { coreAppFetch } from './coreAppClient'

/* ============================================================================================== */
/* ================================== General Functions ========================================= */
/* ============================================================================================== */

export const momentNow = (format) => moment().format(format)
export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
export const momentDateDT = (date, format = 'DD MMM YYYY hh:mm A') => moment(date)?.format(format)
export const momentDate = (date, format = 'DD MMM YYYY hh:mm A') => moment(date, 'x').format(format)
export const momentEndDay = (date, format) => moment(date, 'x').endOf('day').format(format)
export const momentStartDay = (date, format) => moment(date, 'x').startOf('day').format(format)
export const momentAddDays = (date, days, format) => momentStartDay(moment(date, 'x').add(days, 'days'), format)
export const momentSubtractDays = (date, days, format) => momentStartDay(moment(date, 'x').subtract(days, 'days'), format)

export const check = (Param) => Param !== null && Param !== undefined
export const checkArray = (Param) => !!Param && Param.constructor === Array
export const currentCollection = (path) => path.split('/')[1]
export const ReadableString = (string) => string && string.replace(/([A-Z])/g, ' $1')
export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1)
export const formatName = (firstName, lastName) => (firstName ? `${firstName || ''} ${lastName || ''}` : '')
export const formatPhoneNumber = (phoneNumber) =>
	phoneNumber && `${phoneNumber?.replace('+92', '0')?.slice(0, 4)}-${phoneNumber?.replace('+92', '0')?.slice(4)}`

export const Loader = () => (
	<Layout.Content className='h-full flex justify-center items-center !bg-white rounded-lg pb-2 overflow-y-hidden shadow-[0_1px_8px_rgba(0,0,0,0.16)]'>
		<Spin tip={<p className='BoldFont FontSize16 PrimaryColor MarginTop'>Loading...</p>} size='large' />
	</Layout.Content>
)

export const RemoveDuplicates = (array, key) => {
	return array.filter((value, index) => index === array.findIndex((obj) => obj[key] === value[key]))
}

export function range(start, end) {
	var array = new Array(end - start + 1)
	for (let i = 0; i < end - start + 1; i++) array[i] = start + i
	return array
}

export const AdvancedSearchAPI =
	process.env.REACT_APP_PROJECT_ID === 'bridgelinx-dev'
		? 'https://backend.dev.bridgelinxpk.com/advancedSearch'
		: process.env.REACT_APP_PROJECT_ID === 'bridgelinx-client' && 'https://backend.bridgelinxpk.com/advancedSearch'

export const RBACSwitch = (userType, collection, action) => {
	return RBACEnum[userType]?.[action]?.includes(collection)
}

export const biltyObjectFunction = (bilty) => {
	const biltyDataObject = {}
	bilty?.forEach((bilty) => (biltyDataObject[bilty?.biltyNumber || undefined] = bilty))
	return biltyDataObject
}

export const documentBiltiesObjectFunction = (bilty) => {
	const biltyDataObject = {}
	bilty?.forEach((bilty) => (biltyDataObject[bilty?.documentNumber || undefined] = bilty))
	return biltyDataObject
}

export const documentOrdersMapFunction = (data) => {
	const separateDocumentData = {}
	data?.forEach(
		(record) => (separateDocumentData[record?.documentNumber || undefined] = [...(separateDocumentData[record?.documentNumber] || []), record])
	)
	return separateDocumentData
}

/* ============================================================================================== */
/* ================================== Order Filter Functions ==================================== */
/* ============================================================================================== */

export const FilterOrdersByBiltyState = (allOrders, tabStatus) => {
	let orders = allOrders
	if (tabStatus === 'issuance') {
		orders = orders?.filter((order) => !order?.totallyMoved && ['Partial Ongoing', 'Partial Completed', 'Order Confirmed']?.includes(order?.status))
	} else if (tabStatus === 'inProgress') {
		orders = orders?.filter((order) => !order?.bilty?.[0]?.isInformationComplete && ['Job Ongoing', 'Job Completed']?.includes(order?.status))
	} else if (tabStatus === 'completed') {
		orders = orders?.filter((order) => order?.bilty?.[0]?.isInformationComplete && ['Job Ongoing', 'Job Completed']?.includes(order?.status))
	}
	return orders
}

export const filterDataFunction = (props) => {
	const { FilteredOrders, tabStatus, keyword, filterProperty, selectedOrders, segment } = props
	let FilteredData = FilteredOrders
	if (FilteredData?.length > 0 && keyword !== '' && filterProperty) {
		FilteredData = searchFields(FilteredData, keyword, filterProperty)
	}
	if (tabStatus === 'issuance') {
		if (selectedOrders?.length > 0) {
			FilteredData = filterOrdersByType({ segment, orders: FilteredData, selectedOrders })
		}
	}
	return FilteredData
}

export const filterOrdersByType = (props) => {
	const { segment, orders, selectedOrders } = props

	let returnOrders = orders
	const selectedOrder = selectedOrders?.[0]

	if (segment === 'Import') {
		const selectedOrderMovementType = selectedOrder?.movementType
		const selectedOrderContainerDimension = selectedOrder?.dimension

		if (['Import', 'DoubleTwenty']?.includes(selectedOrderMovementType)) {
			returnOrders = returnOrders?.filter((order) => ['Import', 'DoubleTwenty']?.includes(order?.movementType))
			returnOrders = returnOrders?.filter((order) => order?.dimension === selectedOrderContainerDimension)
		} else if (selectedOrderMovementType === 'ImportShifting') {
			returnOrders = returnOrders?.filter((order) => order?.movementType === 'ImportShifting')
		}
	} else if (segment === 'Export') {
		const selectedOrderMovementType = selectedOrder?.movementType
		const selectedOrderContainerDimension = selectedOrder?.dimension

		if (['Export', 'DoubleTwenty']?.includes(selectedOrderMovementType)) {
			returnOrders = returnOrders?.filter((order) => ['Export', 'DoubleTwenty']?.includes(order?.movementType))
			returnOrders = returnOrders?.filter((order) => order?.dimension === selectedOrderContainerDimension)
		} else if (selectedOrderMovementType === 'ExportShifting') {
			returnOrders = returnOrders?.filter((order) => order?.movementType === 'ExportShifting')
		}
	} else if (segment === 'LongHaul') {
		const selectedOrderPreference = selectedOrder?.preferences?.lotOrder
		returnOrders = returnOrders?.filter((order) => order?.preferences?.lotOrder === selectedOrderPreference)
	}

	return returnOrders
}

export const checkCombinations = (props) => {
	const { record, selectedOrders } = props

	const selectedOrder = selectedOrders?.[0]
	const selectedOrderUnit = selectedOrders?.find((order) => order?.movedUnits)?.movedUnits
	const selectedOrderDimension = selectedOrder?.dimension || selectedOrder?.vehicleInfo?.vehicleType
	const selectedOrderPreference = selectedOrder?.preferences
	const singleOrderMovementType = record?.movementType

	if (
		(singleOrderMovementType === 'Import' || singleOrderMovementType === 'Export' || singleOrderMovementType === 'DoubleTwenty') &&
		(selectedOrderDimension === 'xl40ft' || selectedOrderDimension === 'xl40ftHC' || selectedOrderDimension === 'xl40ftOT') &&
		!selectedOrders.find((order) => order?._id === record?._id) &&
		selectedOrders?.length === 1
	) {
		return true
	} else if (
		(singleOrderMovementType === 'Import' || singleOrderMovementType === 'Export' || singleOrderMovementType === 'DoubleTwenty') &&
		selectedOrderDimension === 'xl20ft' &&
		!selectedOrders.find((order) => order?._id === record?._id) &&
		selectedOrders?.length >= 2
	) {
		return true
	} else if (
		singleOrderMovementType === 'LongHaul' &&
		!selectedOrders.find((order) => order?._id === record?._id) &&
		!selectedOrderPreference?.lotOrder &&
		selectedOrders?.length === 1
	) {
		return true
	} else if (selectedOrderUnit === 'Kilos' && record?.movedUnits === 'Units' && !selectedOrders.find((order) => order?._id === record?._id)) {
		return true
	} else if (selectedOrderUnit === 'Units' && record?.movedUnits === 'Kilos' && !selectedOrders.find((order) => order?._id === record?._id)) {
		return true
	}
	return false
}

/* ============================================================================================== */
/* ================================= Combine Orders Function ==================================== */
/* ============================================================================================== */

export const combineChildOrders = (props) => {
	const { orders, values } = props
	const combinedOrders = orders
	const combinedOrdersType = combinedOrders?.map((value) => value?.type).pop()
	const combinedOrderNumbers = combinedOrders?.map((value) => value?.subOrderNumber)
	const combinedRefNumbers = [...new Set(combinedOrders?.map((value) => value?.preferences?.refNumber))]
	const combinedBusinessName = [...new Set(combinedOrders?.map((value) => value?.businessName))]
	const combinedBusinessCode = [...new Set(combinedOrders?.map((value) => value?.businessCode))]
	const combinedOrdersOrderCategory = [...new Set(combinedOrders?.map((value) => value?.orderCategory))]
	const combinedOrderCategory = combinedOrdersOrderCategory?.includes('Destuffing')
		? 'Destuffing'
		: combinedOrdersOrderCategory?.includes('Shifting') && 'Shifting'

	const combinedVesselCutoffDT = combinedOrdersType === 'Export' && [...new Set(combinedOrders?.map((value) => value?.vesselCutoffDT))]
	const combinedLotOrder =
		combinedOrdersType === 'LongHaul' && [...new Set(combinedOrders?.map((value) => value?.preferences?.lotOrder))]?.includes(true)
	const combinedDocumentNumber = ['Import', 'Export']?.includes(combinedOrdersType) && [
		...new Set(combinedOrders?.map((value) => value?.documentNumber)),
	]
	const combinedClearingAgents = ['Import', 'Export']?.includes(combinedOrdersType) && [
		...new Set(combinedOrders?.map((value) => value?.clearingAgents?.map((value) => value))?.flat()),
	]
	const combinedShippingLine = ['Import', 'Export']?.includes(combinedOrdersType) && [...new Set(combinedOrders?.map((value) => value?.shippingLine))]
	const combinedContainerNumbers = ['Import', 'Export']?.includes(combinedOrdersType) && combinedOrders?.map((value) => value?.containerNumber)

	const combinedOrderLocations = {}

	combinedOrders?.forEach((value) =>
		value?.OrderLocations?.forEach((location) => {
			combinedOrderLocations[location?.locationType] = [...new Set([...(combinedOrderLocations?.[location?.locationType] || []), location?.Location])]
		})
	)

	let combinedShipmentInfos = {}
	let combinedContainerInfos = {}

	if (['Import', 'Export']?.includes(combinedOrdersType)) {
		combinedOrders?.forEach((subOrder) => {
			combinedContainerInfos[subOrder.dimension] = [
				...(combinedContainerInfos?.[subOrder?.dimension] || []),
				{
					status: subOrder?.status,
					containerNumber: subOrder?.containerNumber,
					freightType: subOrder?.freightType,
					freightWeight: subOrder?.freightWeight,
				},
			]
		})
	} else if (combinedOrdersType === 'LongHaul') {
		combinedOrders?.forEach((subOrder) => {
			combinedShipmentInfos[`${subOrder?.vehicleType}`] = [
				...(combinedShipmentInfos?.[`${subOrder?.vehicleType}`] || []),
				{
					freightCount: subOrder?.shipmentInfo?.freightCount,
					freightType: subOrder?.shipmentInfo?.freightType,
					freightWeight: subOrder?.shipmentInfo?.freightWeight,
				},
			]
		})
	}

	return {
		type: combinedOrdersType,
		...(combinedOrderCategory && { movementType: combinedOrderCategory }),
		subOrderNumber: combinedOrderNumbers,
		refNumber: combinedRefNumbers,
		businessName: combinedBusinessName,
		businessCode: combinedBusinessCode,
		OrderLocations: combinedOrderLocations,
		...(combinedOrdersType === 'Export' && { vesselCutoffDT: combinedVesselCutoffDT }),
		...(combinedOrdersType === 'LongHaul' && { shipmentInfos: combinedShipmentInfos, lotOrder: combinedLotOrder }),
		...(['Import', 'Export']?.includes(combinedOrdersType) && {
			containerInfos: !['Shifting', 'Destuffing']?.includes(combinedOrderCategory)
				? combinedContainerInfos
				: orders?.map((subOrder) => ({
						status: subOrder?.status,
						movedUnits: values?.movedUnits || subOrder?.movedUnits,
						partialMatched: !!values?.partialMatch[subOrder?._id] || subOrder?.partialMatched,
						movedCount: values?.partialMatch[subOrder?._id]?.movedCount || subOrder?.movementCount,
						totalCount: values?.partialMatch[subOrder?._id]?.totalCount || subOrder?.totalCount,
						containerNumber: subOrder?.containerNumber,
						freightType: subOrder?.freightType,
						freightWeight: subOrder?.freightWeight,
				  })),
			containerNumber: combinedContainerNumbers,
			shippingLine: combinedShippingLine,
			documentNumber: combinedDocumentNumber,
			clearingAgents: combinedClearingAgents,
		}),
	}
}

/* ============================================================================================== */
/* ================================= Subscription Functions ===================================== */
/* ============================================================================================== */

export const updateData = (props) => {
	const { prev, subscriptionData, segment, action, setAtom } = props
	const segmentQuery = GraphQlEnum[segment]?.fetch?.[action]?.queryOutput
	const segmentSubscription = GraphQlEnum[segment]?.listen?.[action]?.subscriptionOutput
	let order
	// console.log({ subscriptionData })
	// console.log('prev', prev[segmentQuery])
	if (segment === 'BiltyOps') {
		order = subscriptionData?.data?.[segmentSubscription]
	} else {
		order = JSON.parse(JSON.stringify(subscriptionData?.data?.[segmentSubscription]))
		// console.log('orderParsed', order)
		if (action === 'normal') {
			order = {
				...order,
				ParentOrder: {
					...order?.ParentOrder,
					Movements: order?.ParentOrder?.Movements?.filter(
						(movement) => !['Order Cancelled']?.includes(movement?.ChildOrder?.[GraphQlEnum[segment]?.childType]?.status)
					)?.map((movement) => ({
						...movement,
						...((movement?.status === 'Matched' || movement?.status === 'PartialMatched') && {
							Job: {
								...movement?.Job,
								bilty: movement?.Job?.bilty?.sort((a, b) => b?.createdAt - a?.createdAt),
							},
						}),
					})),
				},
			}
		} else {
			order = {
				...order,
				bilty: order?.bilty?.sort((a, b) => b?.createdAt - a?.createdAt),
			}
		}
	}

	let orders = []
	let existing = {}
	Object.assign(existing, prev)
	Object.assign(orders, prev[segmentQuery])

	const index = existing[segmentQuery]?.findIndex((value) => value?._id === order?._id)
	if (index !== -1) {
		orders[index] = order
		existing[segmentQuery] = orders
		// console.log('overwriteOrder', existing)
		// console.log('totalOrdersAfter', orders?.length)
	} else {
		orders.unshift(order)
		existing[segmentQuery] = orders
		// console.log('addedOrder', existing)
		// console.log('totalOrdersAfter', orders?.length)
	}
	setAtom(existing[segmentQuery])
	return existing
}

/* ============================================================================================== */
/* ================================ Driver Status Functions ===================================== */
/* ============================================================================================== */

export const checkDriverStatus = (props) => {
	const { journeys, status, driverSubStatus = null } = props
	let flag = false
	let requiredStatus = null

	for (let i = journeys?.length - 1; i >= 0; i--) {
		const driverStatusHistory = journeys[i]?.DriverStatusHistories
		for (let j = driverStatusHistory?.length - 1; j >= 0; j--) {
			if (driverStatusHistory[j]?.status === status) {
				requiredStatus = driverStatusHistory[j]
				break
			}
		}
	}
	if (requiredStatus) {
		if (driverSubStatus === null) {
			flag = true
		} else {
			for (let k = requiredStatus?.DriverStatusJourneys?.length - 1; k >= 0; k--) {
				if (requiredStatus?.DriverStatusJourneys[k]?.status === driverSubStatus) {
					flag = true
					break
				}
			}
		}
	}
	return flag
}

export const getUnloadingTimestamp = (props) => {
	const { journeys, status, driverSubStatus } = props
	let timestamp = null
	let requiredStatus = null

	for (let i = journeys?.length - 1; i >= 0; i--) {
		const driverStatusHistory = journeys[i]?.DriverStatusHistories
		for (let j = driverStatusHistory?.length - 1; j >= 0; j--) {
			if (driverStatusHistory[j]?.status === status) {
				requiredStatus = driverStatusHistory[j]
				break
			}
		}
	}
	if (requiredStatus) {
		if (driverSubStatus === null) {
			timestamp = null
		} else {
			for (let k = requiredStatus?.DriverStatusJourneys?.length - 1; k >= 0; k--) {
				if (requiredStatus?.DriverStatusJourneys[k]?.status === driverSubStatus) {
					timestamp = requiredStatus?.DriverStatusJourneys[k]?.timestamp
					break
				}
			}
		}
	}
	return timestamp
}

export const getLastTrackingStatus = (driverStatusHistory) => {
	let lastStatusJourney = null
	const statusJourney = driverStatusHistory?.DriverStatusJourneys
	if (statusJourney?.length > 0) {
		const statusJourneyLastSubStatus = statusJourney?.find((substatus) => substatus?.type !== 'breakdown' && substatus?.type !== 'alert')
		if (statusJourneyLastSubStatus) {
			lastStatusJourney = statusJourneyLastSubStatus
		}
	}
	return lastStatusJourney
}

/* ============================================================================================== */
/* ======================================= Search Functions ===================================== */
/* ============================================================================================== */

export const searchFields = (data, keyword, filterProperty) => {
	if (keyword.length > 0) {
		if (typeof filterProperty === 'object') {
			/* eslint-disable */
			const AllPropertiesData = filterProperty.map((prop) => {
				if (typeof prop === 'string') {
					return data.filter((singleObj) => {
						if (check(singleObj[prop])) {
							return (singleObj[prop] + '').toLowerCase().includes(keyword.toLowerCase())
						}
					})
				} else if (typeof prop === 'object') {
					return data.filter((singleObj) => filterObject(singleObj, prop, 0, keyword))
				}
			})
			let FilteredData = []
			for (let i = 0; i < AllPropertiesData.length; i++) {
				FilteredData = FilteredData.concat(AllPropertiesData[i])
			}
			const UniqueFilteredData = [...new Set(FilteredData)]
			return UniqueFilteredData
		} else {
			const FilteredData = data.filter((singleObj) => {
				if (check(singleObj[filterProperty])) {
					return (singleObj[filterProperty] + '').toLowerCase().includes(keyword.toLowerCase())
				}
			})
			return FilteredData
		}
	} else {
		return data
	}
}

export const filterObject = (singleObj, prop, index, keyword) => {
	let flag = false
	if (singleObj[prop[index]] !== null && singleObj[prop[index]] !== undefined) {
		if (typeof singleObj[prop[index]] === 'object') {
			flag = filterObject(singleObj[prop[index]], prop, index + 1, keyword)
		} else if (typeof singleObj[prop[index]] === 'string' || typeof singleObj[prop[index]] === 'number') {
			return (singleObj[prop[index]] + '').toLowerCase().includes(keyword.toLowerCase())
		}
	}
	return flag
}

/* ============================================================================================== */
/* ========================== Save and Print Bilty Document Functions =========================== */
/* ============================================================================================== */

export const retryCatch = async ({ delay = 0, maxRetries = 0, executionFunction }) => {
	let count = 0
	while (true) {
		try {
			const response = await executionFunction()
			if (response?.status === 200 || response?.status === 201) {
				return Promise.resolve(response)
			} else {
				throw Error(response)
			}
		} catch (error) {
			count += 1
			if (count === maxRetries) {
				return Promise.reject(error)
			} else {
				await refreshAuthToken()
				await new Promise((r) => setTimeout(r, delay))
				continue
			}
		}
	}
}

export const generateSaveBilty = async ({ body }) => {
	const response = await coreAppFetch('bilty/save', {
		method: 'POST',
		body: JSON.stringify({
			record: body,
		}),
	})
	return response
}

export const printPdf = (pdf) => {
	var blob = new Blob([pdf], { type: 'application/pdf' })
	var url = URL.createObjectURL(blob)
	var pdfAsDataUri = url
	let myWindow = window.open(pdfAsDataUri)
	myWindow.print()
	myWindow.focus()
}

export const printGeneratedBilty = async ({ values, record, bilty, setLoading }) => {
	setLoading(true)
	console.log({ ...record, ...values, bilty: { _id: bilty?._id, biltyNumber: bilty?.biltyNumber } })
	try {
		const response = await coreAppFetch('bilty/generate', {
			method: 'POST',
			body: JSON.stringify({
				record: { ...record, ...values, bilty: { _id: bilty?._id, biltyNumber: bilty?.biltyNumber } },
				type: 'print',
			}),
		})
		if (!response.ok) {
			throw new Error(`Bilty generate failed: ${response.status}`)
		}
		const pdfBytes = new Uint8Array(await response.arrayBuffer())
		printPdf(pdfBytes)
	} finally {
		setLoading(false)
	}
}
